export default __webpack_public_path__ + "static/media/Planit_Brand_dark.83384dbb.svg";